/* eslint-disable import/no-anonymous-default-export */
import en from "./en-US";
import tr from "./tr-TR";

export default {
  ...en,
  ...tr,
};
